
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './can-explanation';
const mainimage = '/Images/modals1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "can" },
];

const Can = () => (
  <GrammarPageLayout
    level="A2"
    title="Can/Could"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Modal Verbs Exercises"
    seoDescription="Use can, could, may, might, must, and should for ability, permission, possibility, advice, and necessity. A2 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default Can;
